import Grid from '@mui/material/Grid'
import React from 'react'
import FixedRoutePricing from './FixedRoutePricing'
import FixedRoutes from './FixedRoutes'

const FixedRoutesComponent = () => {
  return (
    <Grid container spacing={4} direction="column">
      <FixedRoutes />

      <FixedRoutePricing />
    </Grid>
  )
}

export default FixedRoutesComponent
